import React from "react";

import { Routes, Route } from "react-router-dom";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

//redux
import { useSelector } from "react-redux";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";
import CustomerRouteGuard from "./components/Common/CustomerRouteGuard";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/index";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import "./assets/scss/preloader.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { createSelector } from 'reselect';

// Apollo Client for GraphQL
import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from './helpers/graphql_client';

// Auth Context
import { AuthProvider } from './contexts/AuthContext';

// Dev Debug Panel
import PermissionDebugPanel from './components/Dev/PermissionDebugPanel';
import SessionActivityManager from './components/Common/SessionActivityManager';

// Access Denied Page
import AccessDenied from './pages/Utility/AccessDenied';

//api config
// import config from "./config";

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig);

const App = () => {

  const selectCalendar = createSelector(
    (state: any) => state.Layout,
    (state) => ({
      layoutType: state.layoutType,
    })
);

const { layoutType } = useSelector(selectCalendar);

  function getLayout() {
    let layoutCls: Object = VerticalLayout;
    switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout: any = getLayout();
  return (
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <SessionActivityManager />
        <React.Fragment>
          <Routes>
            {authRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                key={idx}
              />
            ))}

            {userRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    <CustomerRouteGuard>
                      <Layout>{route.component}</Layout>
                    </CustomerRouteGuard>
                  </Authmiddleware>
                }
                key={idx}
              />
            ))}

            {/* Access Denied Route */}
            <Route
              path="/access-denied"
              element={
                <Authmiddleware>
                  <Layout>
                    <AccessDenied />
                  </Layout>
                </Authmiddleware>
              }
            />
          </Routes>
          
          {/* Dev Permission Debug Panel (only in development) */}
          <PermissionDebugPanel />
        </React.Fragment>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;
